import type { IconNode } from '../types';

/**
 * @name bell-concierge-off
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMiAyIDIwIDIwIiAvPgogIDxwYXRoIGQ9Ik0xMiA0djIuMyIgLz4KICA8cGF0aCBkPSJNMTAgNGg0IiAvPgogIDxwYXRoIGQ9Ik0xOS44IDE0LjFhOCA4IDAgMCAwLTUuOS01LjkiIC8+CiAgPHBhdGggZD0iTTguNyA4LjdDNS45IDEwIDQgMTIuOCA0IDE2IiAvPgogIDxwYXRoIGQ9Ik0xNiAxNkg0YTIgMiAwIDAgMC0yIDJ2MmgxOCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/bell-concierge-off
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const bellConciergeOff: IconNode = [
  ['path', { d: 'm2 2 20 20', key: '1ooewy' }],
  ['path', { d: 'M12 4v2.3', key: 'zxpn89' }],
  ['path', { d: 'M10 4h4', key: '1xpv9s' }],
  ['path', { d: 'M19.8 14.1a8 8 0 0 0-5.9-5.9', key: '140krv' }],
  ['path', { d: 'M8.7 8.7C5.9 10 4 12.8 4 16', key: 'oh572d' }],
  ['path', { d: 'M16 16H4a2 2 0 0 0-2 2v2h18', key: 'gdpafm' }],
];

export default bellConciergeOff;
